import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-my-skills',
  template: `
    <app-navigation-secondary-my-skills></app-navigation-secondary-my-skills>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryMySkillsComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/compat/compat-navigation-secondary-my-skills.component.ts